import { Component, Input } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { DialogFullscreenCodeComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-customize-object-admin-config',
  templateUrl: './customize-object-admin-config.component.html',
  styleUrls: ['./customize-object-admin-config.component.scss']
})
export class AtwCustomizeObjectAdminConfig extends AtwUpdateDbComponent {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  activeTab: string = 'html'; // Tab mặc định
  @Input() type: any;


  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogFullscreenCodeComponent>,
    public vhEventMediator: VhEventMediator,
    public vhQueryAutoWeb: VhQueryAutoWeb,
        public functionService: FunctionService
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  // /**
  // *Hàm update config vào database.
  // */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {[this.device + '_config']: this.config,})
  // }



  // /**
  // *Hàm update class vào database.
  // */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     [this.device + '_class']: this.class,
  //   }).then((bool: any) => {
      
  //   });
  // }

  generateCode() {
    // Bọc đoạn mã CSS và JS bằng thẻ tương ứng
    this.config.code_value.css = this.wrapWithStyleTag(this.config.code_value.css);
    this.config.code_value.js = this.wrapWithScriptTag(this.config.code_value.js);

    // Cập nhật cấu hình
    this.updateConfig();
    this.vhEventMediator.notifyOnConfigChanged({ code: this.objectChoosing._id, status: 'update-UI', id_parent: this.objectChoosing.id_block || this.objectChoosing.id_object });
  }
  
  wrapWithScriptTag(jsCode: string): string {
    const trimmedCode = jsCode.trim();
    if (trimmedCode.startsWith('<script') && trimmedCode.endsWith('</script>')) {
      return jsCode; // Nếu đã có <script>, không thay đổi
    }
    return `<script>\n${trimmedCode}\n</script>`; // Thêm thẻ <script> nếu chưa có
  }
  
  wrapWithStyleTag(cssCode: string): string {
    const trimmedCode = cssCode.trim();
    if (trimmedCode.startsWith('<style') && trimmedCode.endsWith('</style>')) {
      return cssCode; // Nếu đã có <style>, không thay đổi
    }
    return `<style>\n${trimmedCode}\n</style>`; // Thêm thẻ <style> nếu chưa có
  }

  toggleFullscreen() {
    const dialogRef = this.dialog.open(DialogFullscreenCodeComponent, {
      width: '800px',
      maxWidth: '100%',
      data: this.config.code_value,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.generateCode()
    });
  }

}
